import { render, staticRenderFns } from "./route-left.vue?vue&type=template&id=46e8a0ca&scoped=true&"
import script from "./route-left.vue?vue&type=script&lang=ts&"
export * from "./route-left.vue?vue&type=script&lang=ts&"
import style0 from "./route-left.vue?vue&type=style&index=0&id=46e8a0ca&prod&lang=scss&scoped=true&"
import style1 from "./route-left.vue?vue&type=style&index=1&id=46e8a0ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e8a0ca",
  null
  
)

export default component.exports